// Configuração central do app
const REMOTE_API_BASE = "https://www.fazendalagoazul.com.br/api";
export const APP_VERSION = "3.11.01";

export function isNativeShell() {
  try {
    const protocol = String(window?.location?.protocol || '').toLowerCase();
    return !!protocol && protocol !== 'http:' && protocol !== 'https:';
  } catch (e) {
    return false;
  }
}


function detectMapsPlatform() {
  try {
    const ua = String(window?.navigator?.userAgent || '').toLowerCase();
    if (isNativeShell()) {
      if (/iphone|ipad|ipod|ios/.test(ua)) return 'ios';
      if (/android/.test(ua)) return 'android';
    }
  } catch (e) {}
  return 'site';
}

export function buildApiUrl(path) {
  const cleanPath = String(path || '').replace(/^\/+/, '');
  if (isNativeShell()) return `${REMOTE_API_BASE}/${cleanPath}`;
  return `/api/${cleanPath}`;
}

export const API_BASE_URL = isNativeShell() ? REMOTE_API_BASE : "/api";
export const API_URL = buildApiUrl("sync.php");
export const PING_URL = buildApiUrl("ping.php");
export const MAPS_KEY_URL = `${buildApiUrl("maps-key.php")}?platform=${encodeURIComponent(detectMapsPlatform())}`;
export const NOTIFICATIONS_DEVICE_URL = buildApiUrl("notifications-device.php");
export const LIVE_ACTIVITY_DEVICE_URL = buildApiUrl("live-activity-device.php");
export const LIVE_ACTIVITY_PUSH_TEST_URL = buildApiUrl("live-activity-push-test.php");
export const LIVE_ACTIVITY_APNS_CONFIG_URL = buildApiUrl("live-activity-apns-config.php");
export const LIVE_ACTIVITY_APNS_EVENTS_URL = buildApiUrl("live-activity-apns-events.php");
export const LIVE_TOUCH_DIAGNOSTIC_URL = buildApiUrl("live-touch-diagnostic.php");
export const ORDER_LIVE_HYDRATE_URL   = buildApiUrl("order-live-hydrate.php");
export const SERVICE_LIVE_HYDRATE_URL = buildApiUrl("service-live-hydrate.php");
export const OCCURRENCE_LIVE_HYDRATE_URL = buildApiUrl("occurrence-live-hydrate.php");
export const NOTIFICATIONS_READ_URL = buildApiUrl("notifications-read.php");
export const USER_MODULE_USAGE_URL = buildApiUrl("user-module-usage.php");
export const BOOT_TELEMETRY_URL = buildApiUrl("boot-telemetry.php");
export const SYSTEM_HEALTH_URL = buildApiUrl("system-health.php");
export const DEVICE_REGISTRY_URL = buildApiUrl("device-registry.php");
export const DEVICE_BOOTSTRAP_URL = buildApiUrl("device-bootstrap.php");
export const SECURITY_BACKUPS_URL = buildApiUrl("security-backups.php");
export const MAPS_PLATFORM = detectMapsPlatform();
export const API_SECRET = "TPPENNefl3cqjDLlMkuXKm6KTPwztqRUQ";
export const TREMBO_INTERNAL_API_KEY = process.env.REACT_APP_TREMBO_INTERNAL_API_KEY || "";

// Coleções globais — compartilhadas entre fazendas
export const GLOBAL_COLLECTIONS = ["people","suppliers","providers","serviceTypes","stock","adminGlobalsConfig"];
export const GLOBAL_BOOTSTRAP_PRIORITY = ["adminGlobalsConfig","people","serviceTypes"];
export const GLOBAL_BOOTSTRAP_SECONDARY = GLOBAL_COLLECTIONS.filter((col) => !GLOBAL_BOOTSTRAP_PRIORITY.includes(col));
// v3.2.03: 45s era curto demais — app fechado >45s disparava 8 POSTs no boot.
// 5 minutos cobre a maioria dos boots (app em background, reabertura normal).
// _warmAt é gravado a cada sync bem-sucedido; dentro da janela, tudo é pulado.
export const GLOBAL_SYNC_FRESHNESS_MS = 5 * 60 * 1000;
export const GLOBAL_KEY = (col) => `fz:global:${col}`;
